import { CtaButton } from '@/components/Cta/Cta';
import { Dialog } from '@/components/commons/Dialog';

interface CartItemRemovedModalProps {
  isVisible: boolean;
  hideModal: () => void;
}

export default function CartItemRemovedModal(props: CartItemRemovedModalProps) {
  return (
    <>
      <Dialog
        onClose={() => props?.hideModal()}
        open={props.isVisible}
        // @ts-ignore
        size="xs"
        hideCloseButton={true}
      >
        <Dialog.Panel className="relative h-[30rem] max-h-[12rem] min-h-[8rem] sm:max-h-[14rem] sm:min-h-[10rem] md:max-h-[12rem] md:max-h-[12rem] lg:max-h-[14rem] lg:max-h-[14rem] xl:max-h-[10rem] xl:min-h-[10rem]">
          <h1 className="my-6 text-center text-xl xs:my-10 xs:text-[1.65rem] sm:text-2xl md:my-6 md:text-base lg:text-xl xl:text-2xl">
            Oops, it appears that some items in your cart are no longer
            available.
          </h1>
          <div className="flex justify-center align-middle">
            <CtaButton
              variant="dark"
              className="mt-1 inline-block w-full xxs:w-4/5 sm:w-3/5"
              onClick={() => props?.hideModal()}
            >
              Update Shopping Cart
            </CtaButton>
          </div>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}
